import React from 'react';
import { Checkbox } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const CheckboxCell = ({ value, isChecked, onChange }) => (
  <Checkbox
    borderColor="greyScale.300"
    isChecked={isChecked}
    mb={0}
    value={value}
    onChange={onChange}
  />
);

CheckboxCell.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.number,
  row: PropTypes.shape({
    original: PropTypes.shape({
      project: PropTypes.shape({
        id: PropTypes.number
      })
    })
  })
};
export default CheckboxCell;
